export default __webpack_public_path__ + "static/reward-product-ec-af5b6205ff85e9ce1364800e9fb04078.png";